export default __webpack_public_path__ + "static/media/iconShopCartWhite.037a0547.svg";